import actions from './actions';

const initState = { userGroups: null };

export default function logReducer(state = initState, action) {
  switch (action.type) {
    case actions.USERGROUP_SEARCH_SUCCESS:
      return { ...state, userGroups: action.userGroups };
    case actions.USERGROUP_CREATE_SUCCESS:
      return {
        ...state,
        userGroupCreateSuccess: action.userGroupCreateSuccess,
      };
    case actions.USERGROUP_USERS_SUCCESS:
      return { ...state, userGroupUsers: action.userGroupUsers };
    case actions.USERGROUP_UPDATE_SUCCESS:
      return {
        ...state,
        userGroupUpdateSuccess: action.userGroupUpdateSuccess,
      };
    case actions.USERGROUP_DELETE_SUCCESS:
      return {
        ...state,
        userGroupDeleteSuccess: action.userGroupDeleteSuccess,
      };
    case actions.USERGROUP_ERROR:
      return { ...state, userGroupError: action.userGroupError };
    default:
      return state;
  }
}
